import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import CaseDescriptionElement from "./CaseDescriptionElement";
import CommonButton from "../../../../CommonComponents/CommonButton";
import { textBoxArray } from "../../../../constants/utils";
import {
  getAllCaseDescription,
  postAllCaseDescription,
  getCaseDescription,
} from "../../../../Services/caseDescription.service";
import { useDispatch, useSelector } from "react-redux";
import useToaster from "../../../../customHook/useToaster";
import { caseDescriptionPut } from "../../../../Services/caseManagement.service";
// import { storeAllCaseDescriptions } from "../../../../Redux/Slice/CaseManagementActionsSlice/CaseDescriptionSlice";

const CaseDescription = ({ onSubmit = () => {} }) => {
  // const { caseDescriptions } = useSelector(
  //   (state) => state.CaseDescriptionSlice
  // );
  const caseId = useSelector((state) => state?.CaseDescriptionSlice?.caseId);
  const { showToast } = useToaster();
  const dispatch = useDispatch();
  const [note, setNote] = useState({});
  const InputEvent = (event) => {
    const { name, value } = event.target;
    setNote((prevData) => {
      return {
        ...prevData,
        [name]: value,
      };
    });
  };
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  const addDescriptionHandlerClick = async () => {
    // postAllCaseDescription({ caseId }, note)
    //   ?.then((response) => {
    //     if (response?.success) {
    //       showToast(response?.message, "success", true);
    //     }
    //   })
    //   .catch((err) => {
    //     showToast(err?.response?.data?.message, "error", true);
    //   });
    try {
      // const data = await Promise.all(caseDescriptionPut(secondTabVal.split(" ")[0], {
      //   caseId: caseId,
      //   description: descriptionVal,
      // }))
      const data = await Promise.all(
        Object.keys(note)?.map((key) => {
          return caseDescriptionPut(capitalizeFirstLetter(key), {
            caseId: caseId,
            description: note[key],
          });
        })
      );
      if (data[0]?.success) {
        showToast(data[0]?.message, "success", true);
        onSubmit(true);
      }
    } catch (error) {
      showToast("Error in updating description", "error", true);
    }
  };

  useEffect(() => {
    let data = "";
    getAllCaseDescription({ caseId }, data)
      .then((response) => {
        if (response?.success) {
          setNote({ ...response?.data });
          // dispatch(storeAllCaseDescriptions(response?.data));
        }
      })
      .catch((error) => {});
  }, [caseId]);

  return (
    <Box
      sx={{
        width: "100%",
        height: "auto",
        display: "block",
        mx: "auto",
      }}
    >
      {/* <Typography
        sx={{
          fontWeight: 600,
          fontSize: "1.6rem",
          lineHeight: "1.9rem",
          color: "#505050",
          mb: "2.5rem",
        }}
      >
        Case Description
      </Typography> */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "3.2rem",
        }}
      >
        <div>
          <Grid container spacing="1rem">
            {textBoxArray.map((item) => (
              <Grid item md={3} sm={4} xs={12} key={item?.id}>
                <CaseDescriptionElement
                  textBoxLabel={item.label}
                  name={item.id}
                  value={
                    note.hasOwnProperty(item.id) ? note[item.id] : note.value
                  }
                  onChange={InputEvent}
                  edit={note[item.id] !== "" ? true : false}
                />
              </Grid>
            ))}
          </Grid>
        </div>
        <div
          style={{
            display: "block",
            margin: "auto",
          }}
        >
          <CommonButton
            filledButton={true}
            label="Submit"
            onClick={addDescriptionHandlerClick}
            fontSize="1.4rem"
            sx={{
              width: "10rem",
              height: "4rem",
              boxShadow: "4px 4px 3px rgba(0, 0, 0, 0.25)",
            }}
          />
        </div>
      </Box>
    </Box>
  );
};

export default CaseDescription;
